<template>
  <div id="videos">
    <TopList :navList="navList" @setType="setType"></TopList>
    <Video></Video>
  </div>
</template>

<script>
import TopList from "../../components/topList";
import Video from "./components/video";

export default {
  name: "index",
  components: {
    TopList,
    Video,
  },
  data() {
    return {
      type: 0,
      name: "",
      navList: ["全部", "视频"],
    };
  },
  methods: {
    setType(e) {
      this.type = e;
      this.name = this.navList[e];
    },
  },
};
</script>

<style lang="scss" scoped>
#videos {
}
</style>
